import { Outlet, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
const PrivateRoutes2 = () => {
  
  let itemStr = localStorage.getItem("access_token");

  if (!itemStr) {
    itemStr = null;
  } else {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem("access_token");
      itemStr = null;
      //return null
    }else{
      sessionStorage.setItem("access_token",item.value)
    }
  }

  const isLoggedIn = localStorage.getItem("access_token") || itemStr != null;
  
  if (isLoggedIn) {
    return <Outlet />;
  } else {
    return <Navigate to={"/login"}/>; // Return null when not logged in
  }
};
// const PrivateRoutes2 = () => {
//   const [isTokenValid, setIsTokenValid] = useState(true);

//   useEffect(() => {
//     const checkToken = () => {
//       let itemStr = localStorage.getItem("access_token");

//       if (!itemStr) {
//         // No token found
//         setIsTokenValid(false);
//       } else {
//         const item = JSON.parse(itemStr);
//         const now = new Date();

//         if (now.getTime() > item.expiry) {
//           // If the token is expired, remove it and set validity to false
//           localStorage.removeItem("access_token");
//           setIsTokenValid(false);
//         } else {
//           // Token is valid, proceed to the protected routes
//           setIsTokenValid(true);
//         }
//       }
//     };

//     checkToken();
//   }, []);

//   // If the token is not valid, redirect to login
//   if (!isTokenValid) {
//     return <Navigate to="/login" />;
//   }

//   // If the token is valid, render the outlet (protected routes)
//   return <Outlet />;
// };
export default PrivateRoutes2;
